export const CLIENT_STATS = 'CLIENT_STATS';
export const CLIENT_STATS_SUCCESS = 'CLIENT_STATS_SUCCESS';
export const CLIENT_STATS_ERROR = 'CLIENT_STATS_ERROR';

